var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 9H10a2 2 0 00-2 2v7.346c0 11.203 9.477 14.918 11.375 15.548a1.93 1.93 0 001.25 0C22.525 33.263 32 29.548 32 18.345V11a2 2 0 00-2-2zM10.082 20H20v-9h10v7.346c0 .552-.027 1.103-.082 1.651H20v12c-1.593-.53-9.051-3.465-9.918-11.997z",
    fill: "#DCFE52"
  })));
}
export default SvgIconShield;